<template>
  <div id="login" class="container mt-5">
    <h1>INFORMATIVA AI SENSI DELL'ART. 13 REGOLAMENTO UE N. 679/2016 E DELLA NORMATIVA ITALIANA DI RIFERIMENTO E
        SUCCESSIVE MODIFICAZIONI</h1>
    <p><i>Ultimo aggiornamento: Marzo 2025</i></p>
    <p>Questa informativa sulla privacy ha l’obiettivo di spiegare in modo chiaro quali informazioni vengono raccolte, come vengono utilizzate e quali diritti spettano agli utenti in merito alla loro gestione. L’app “VisadApp” (di seguito “app”) fa parte delle attività del progetto “<i>VivereMeglio: Soluzioni Innovative per l'Assistenza Sanitaria a Domicilio (VISAD)</i>”.</p>
    <p>Si prega di leggere attentamente quanto riportato nelle indicazioni che verranno rilasciate sull’uso e sulle
       modalità di inserimento delle informazioni attraverso l’app e di decidere, in totale libertà, se partecipare o
       meno a questo studio che ha finalità di ricerca scientifica ed è promosso dall’Università degli Studi di Bari
       “Aldo Moro”. Non sono presenti rischi né tantomeno controindicazioni nel partecipare. Se nella presente
       informativa sulla privacy sono presenti termini con i quali non si è concordi, è possibile interrompere
       repentinamente l'utilizzo dei nostri Servizi disinstallando l’app.</p>
    <h3>Sommario</h3>
    <ol>
      <li><a href="#software-mobile">Software mobile</a></li>
      <li><a href="#oggetto-trattamento">Oggetto del trattamento</a></li>
      <li><a href="#base-giuridica">Base giuridica del trattamento</a></li>
      <li><a href="#finalità-del-trattamento">Finalità del trattamento</a></li>
      <li><a href="#modalita-del-trattamento">Modalità del trattamento</a></li>
      <li><a href="#tempo-di-conservazione-dati">Tempo di conservazione dei dati</a></li>
      <li><a href="#accesso-al-trattamento">Accesso al trattamento</a></li>
      <li><a href="#trasferimento-dati">Trasferimento dei dati</a></li>
      <li><a href="#rifiuto-consenso">Natura del conferimento dei dati e conseguenze del rifiuto di rispondere</a></li>
      <li><a href="#informazioni-al-sicuro">Informazioni al sicuro</a></li>
      <li><a href="#diritti-interessato">Diritti dell'interessato</a></li>
      <li><a href="#modalita-esercizio-diritti">Modalità di esercizio del diritto</a></li>
      <li><a href="#aggiornamenti-a-questo-avviso">Aggiornamenti a questo avviso</a></li>
    </ol>


    <hr>

    <h3 id="software-mobile">1. Software mobile</h3>
    <p>
      Con questa informativa si concede la licenza all'utilizzo di una copia completa del codice del Software
      “visadapp” associata all’account posseduto o affittato. Tale licenza ha carattere non esclusivo, non
      trasferibile, revocabile ed è intesa solo per uso personale. È proibito:</p>
    <ol>
      <li>
        Modificare, scomporre, decompilare o effettuare l'ingegneria inversa (reverse engineering) del Software
        Mobile, salvo specifiche disposizioni di legge che prevedono altrimenti;
      </li>
      <li>
        Affittare, locare, prestare, rivendere, concedere in sub-licenza, distribuire o altrimenti trasferire a
        parti terze il Software “visadapp” o condividere in qualsiasi modo con parti terze il Software Mobile;
      </li>
      <li>
        Copiare il Software Mobile;
      </li>
      <li>
        Rimuovere, aggirare, disabilitare, danneggiare o altrimenti interferire con le funzionalità di sicurezza del
        Software Mobile, con le funzionalità che impediscono o limitano l'uso o la copia di qualsiasi contenuto
        accessibile tramite il Software Mobile, o con le funzionalità che applicano dei limiti all'utilizzo del
        Software Mobile;
      </li>
      <li>
        Eliminare il copyright o altre note mostranti il diritto di proprietà del Software Mobile. Periodicamente si
        rilasceranno delle versioni di aggiornamento del Software Mobile, e tali versioni potranno aggiornare
        automaticamente la versione del Software “visadapp” in utilizzo sul dispositivo dell'utente. L'utente
        autorizza l'aggiornamento automatico sul proprio dispositivo mobile e accetta che i termini e le condizioni
        di questo accordo saranno applicati anche agli aggiornamenti. Qualsiasi stringa di codice di parti terze
        inserita nel Software “visadapp” è coperta dalla licenza parti terze o open-source della EULA, che autorizza
        l'uso di tale stringa di codice. La licenza concessa non è una vendita del Software “visadapp” o di una sua
        copia, e tutti i diritti e interessi del Software “visadapp” (e di qualsiasi sua copia) rimangono in capo ai
        partner. È nullo qualsiasi tentativo di trasferimento dei diritti, doveri o obbligazioni sottostanti, salvo
        quanto esplicitamente previsto da questo Accordo.
      </li>
    </ol>

    <hr>

    <h3 id="oggetto-trattamento">2. Oggetto del trattamento</h3>
    <p>
      Si raccolgono informazioni sia quando l’utente interagisce direttamente con l’app sia quando l’app è chiusa (cioè,
      in esecuzione in <i>background</i>). Le informazioni raccolte possono essere divise in base alla fase di
      interazione in
      cui tali informazioni sono raccolte: </p>
    <ul>
      <li>Fase di accesso (o login) – interazione diretta:
        <ul>
          <li>
            <i>Peso</i>: Durante la fase di accesso dell’app, all’utente viene chiesto di inserire il peso, con il fine
                       di
                       calcolare le calorie durante le varie attività rilevate;
          </li>
          <li>
            <i>Referente</i>: Durante la fase di accesso dell’app, viene richiesto il referente dell’utente;
          </li>
          <li>
            <i>Android ID</i>: Durante la fase di accesso dell’app, viene prelevato l'ID associato alla coppia <i>app-dispositivo</i>, con il mero scopo di identificare lo stesso utente (e associare lo stesso UID) nel caso in cui l'app venga disinstallata.
          </li>
        </ul>
      </li>
      <li>Fase di utilizzo – app in background:
        <ul>
          <li>
            <i>Numero di passi</i>: Durante l’utilizzo dell’app, viene raccolto il numero di passi dal sensore integrato
                                  del dispositivo, per monitorare l’attività giornaliera;
          </li>
          <li>
            <i>Posizione GPS (latitudine e longitudine)</i>: Durante l’utilizzo dell’app, vengono raccolte le coordinate
                                                           dell’utente per tracciare i percorsi durante le attività
                                                           motorie;
          </li>
          <li>
            <i>Attività motoria</i>: Durante l’utilizzo dell’app, viene rilevata l’attività motoria per rilevare il tipo
                                   di
                                   movimento (es.: stazionario, camminata, ecc.) tramite la lettura dei sensori
                                   integrati del dispositivo;
          </li>
          <li>
            <i>Calorie</i>: Durante l’utilizzo dell’app, viene calcolato il numero di calorie per stimare il dispendio
                          energetico durante le attività svolte.
          </li>
        </ul>
      </li>
    </ul>
    <p>
      Queste informazioni sono necessarie per mantenere la sicurezza e il funzionamento dell’app, per la risoluzione dei
      problemi e per gli scopi di ricerca interni di raccolta dati e analisi degli errori.
    </p>

    <hr>

    <h3 id="base-giuridica">3. Base giuridica del trattamento</h3>
    <p>
      La base giuridica di tale trattamento di ravvisa nel suo consenso espresso ed inequivocabile (ex art. 6.1, lett.
      A) del GDPR.
    </p>

    <hr>

    <h3 id="finalità-del-trattamento">4. Finalità del trattamento</h3>
    <p>
      Il trattamento dei dati acquisiti ha la finalità di ricerca scientifica e mira a migliorare la gestione della
      salute degli anziani e di persone affette da patologie croniche, mediante l’utilizzo di tecnologie indossabili e
      applicazioni di telemedicina per smartphone. Si ribadisce che non verranno estratte o richieste informazioni
      personali intendendo con esse tutte quelle informazioni che sono utilizzate per identificare e contattare una
      persona, come nome, indirizzo e-mail, username, indirizzo e numero di telefono. I dati che verranno rilevati
      saranno relativi all’interazione dell’UTENTE con l’app. Essi saranno registrati come UTENTE 1, UTENTE 2, UTENTE 3
      e successivi, in modo incrementale e automatizzato, in base all’ordine di login.
    </p>

    <hr>

    <h3 id="modalita-del-trattamento">5. Modalità del trattamento</h3>
    <p>
      Le informazioni raccolte dall’app saranno elaborate per scopi di ricerca con il fine di fornire un supporto alla
      gestione di malattie croniche o anziani. L’app ha lo scopo di raccogliere dati che saranno successivamente
      elaborati per fini statistici e di ricerca.
    </p>

    <hr>

    <h3 id="tempo-di-conservazione-dati">6. Tempo di conservazione dei dati</h3>
    <p>
      Si conserveranno i dati dell’utente per tutto il tempo necessario a soddisfare le finalità descritte
      nella presente informativa sulla privacy, salvo diversamente richiesto dalla legge.
    </p>

    <hr>

    <h3 id="accesso-al-trattamento">7. Accesso al trattamento</h3>
    <p>
      I dati saranno resi accessibili, per le finalità di cui al punto n. 4, ai partner di progetto, che si possono
      identificare con tutto il personale medico-sanitario e collaboratori.
    </p>

    <hr>

    <h3 id="trasferimento-dati">8. Trasferimento dei dati</h3>
    <p>
      I dati non saranno oggetto di trasferimento al di fuori dell'Unione Europea.
    </p>

    <hr>

    <h3 id="rifiuto-consenso">9. Natura del conferimento dei dati e conseguenze del rifiuto di rispondere</h3>
    <p>
      Il conferimento dei dati per le finalità di cui al punto 4 sopra è obbligatorio. In loro assenza, non sarà
      possibile procedere con l'acquisizione dati e raggiungere l'obiettivo del progetto.
    </p>

    <hr>

    <h3 id="informazioni-al-sicuro">10. Informazioni al sicuro</h3>
    <p>
      Premesso che non è possibile risalire all’identità dell’utente (se non nella misura di UTENTE1, UTENTE 2, UTENTE 3
      e così via), si mira anche a proteggere le informazioni d’iterazione utente attraverso un sistema di misure di
      sicurezza organizzative e tecniche.
    </p>
    <p>
      Si sono implementate misure di sicurezza tecniche e organizzative appropriate per proteggere la sicurezza delle
      informazioni che si estraggono dall’app. Tuttavia, nonostante le misure di salvaguardia e gli sforzi per
      proteggere
      le informazioni, nessuna trasmissione elettronica su Internet o tecnologia di archiviazione delle informazioni
      può
      essere garantita come sicura al 100%, quindi non è possibile promettere o garantire che hacker, criminali
      informatici o altre terze parti non autorizzate non saranno in grado di sconfiggere la nostra sicurezza e
      raccogliere, accedere, rubare o modificare in modo improprio le informazioni.
    </p>

    <hr>

    <h3 id="diritti-interessato">11. Diritti dell'interessato</h3>
    <p>
      Secondo le disposizioni del GDPR, l’interessato ha i seguenti diritti nei confronti del Titolare del Trattamento:
    </p>
    <ul>
      <li>
        ottenere la conferma che sia o meno in corso un trattamento di dati personali che lo riguardano e in tal caso,
        di ottenere l'accesso ai dati personali (Diritto di accesso art. 15);
      </li>
      <li>
        di ottenere la rettifica dei dati personali inesatti che lo riguardano senza ingiustificato ritardo (Diritto di
        Rettifica art. 16);
      </li>
      <li>
        ottenere la cancellazione dei dati personali che lo riguardano senza ingiustificato ritardo e il titolare del
        trattamento ha l'obbligo di cancellare senza ingiustificato ritardo i dati personali, se sussistono determinate
        condizioni (Diritto all’oblio art. 17);
      </li>
      <li>
        ottenere la limitazione del trattamento in determinate ipotesi (Diritto alla limitazione del trattamento art.
        18);
      </li>
      <li>
        ricevere in un formato strutturato, di uso comune e leggibile da dispositivo automatico i dati personali che lo
        riguardano forniti e ha il diritto di trasmettere tali dati a un altro Titolare del trattamento, senza
        impedimenti da parte del titolare del trattamento cui li ha forniti, in determinati casi (Diritto alla
        portabilità dei dati
        art. 20);
      </li>
      <li>
        opporsi in qualsiasi momento, per motivi connessi alla sua situazione particolare, al trattamento dei dati
        personali che lo riguardano (Diritto di opposizione art 21);
      </li>
      <li>
        ricevere senza ingiustificato ritardo comunicazione della violazione dei dati personali subita dal Titolare del
        trattamento (Art. 34);
      </li>
      <li>
        revocare il consenso espresso in qualsiasi momento (Condizioni per il consenso art. 7).
      </li>
    </ul>
    <p>
      Ove applicabili, l’interessato ha altresì i diritti di cui agli artt. 16-21 GDPR (Diritto di rettifica, diritto
      all’oblio, diritto di limitazione di trattamento, diritto alla portabilità dei dati, diritto di opposizione),
      nonché il diritto di reclamo all’Autorità Garante.
    </p>

    <hr>

    <h3 id="modalita-esercizio-diritti">12. Modalità di esercizio del diritto</h3>
    <p>
      Se si hanno domande o commenti su questo avviso: <a
      href="mailto:mailinfovisad@gmail.com">mailinfovisad@gmail.com</a>.
    </p>

    <hr>

    <h3 id="aggiornamenti-a-questo-avviso">13. Aggiornamenti a questo avviso</h3>
    <p>
      Il seguente avviso verrà aggiornato e modificato in conformità alle leggi pertinenti.
      La versione aggiornata sarà indicata da una data "Revisionata" aggiornata e essa entrerà in vigore non appena sarà
      accessibile. Si invita a rivedere e rileggere questa informativa sulla privacy.
    </p>

  </div>

</template>

<script>

import {useHead} from "@vueuse/head";

export default {
  name: 'PrivacyPolicy',
  setup() {
    useHead({
      title: 'VISAD Dashboard - Informativa Privacy'
    });
  },
}

</script>

<style scoped>

</style>